import { canv } from '@/canv/global.js'

export class shapeManualOperation {

    constructor() {

    }

    drawRoundedRect(x, y, w, h, r) {
        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        canv.ctx.beginPath();
        canv.ctx.moveTo(x+r, y);
        canv.ctx.arcTo(x+w, y,   x+w, y+h, r);
        canv.ctx.arcTo(x+w, y+h, x,   y+h, r);
        canv.ctx.arcTo(x,   y+h, x,   y,   r);
        canv.ctx.arcTo(x,   y,   x+w, y,   r);
        canv.ctx.closePath();
    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width/2 - 2 * horizontalPadding;
        var allowedHeight = height - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {

        var r = height / 30;
        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + 2*r, y); // 2*r потому что с просто r немного не правильно отображается угол
        canv.ctx.arcTo(x + width, y, x + width * 3/4, y + height, r);
        canv.ctx.arcTo(x + width * 3/4, y + height, x + width/4, y + height, r);
        canv.ctx.arcTo(x + width/4, y + height, x, y, r);
        canv.ctx.arcTo(x, y, x + width, y, r);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="107" height="80" viewBox="0 0 107 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.446684 14.5683C-1.63926 7.26743 3.84263 0 11.4355 0H95.4189C103.012 0 108.493 7.26743 106.408 14.5683L90.0812 71.7111C88.6795 76.6174 84.1949 80 79.0923 80H27.7621C22.6595 80 18.1749 76.6174 16.7732 71.7111L0.446684 14.5683Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.40508 16.6404L3.92431 16.7778L4.40507 16.6404L0.58527 3.27108C0.188494 1.88236 1.23122 0.5 2.67549 0.5H22.3245C23.7688 0.5 24.8115 1.88234 24.4147 3.27108C24.4147 3.27109 24.4147 3.27109 24.4147 3.2711L20.5949 16.6404C20.3283 17.5736 19.4753 18.2171 18.5047 18.2171H6.4953C5.52472 18.2171 4.6717 17.5736 4.40508 16.6404Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
